export function satisfaction_mouseIn_1(event) {
	$w('#satisfactiontext').show()
}

export function satisfaction_mouseOut_1(event) {
	$w("#satisfactiontext").hide()
}